import { Modal } from 'bootstrap'
import { ErrorApi } from '../identidad/cliente-identidad.js'
import { cerrarCarga, mostrarCarga, notificar } from '../fundacion/alertas.js'
import {
  abrirExpediente,
  actualizarIdentificacion,
  cargarFotoIdentificacion,
  cerrarExpediente,
  consultarDocumentoLegal,
  consultarIdentificacion,
  decidirDocumentoLegal,
  listarDepartamentos,
  listarExpedientes,
  listarMunicipios,
  type DocumentoLegal,
  type Expediente,
  type Identificacion,
  type Ubicacion,
} from './cliente-expedientes.js'
import { mostrarSeguimiento } from '../seguimiento/interfaz-seguimiento.js'
import { listarSeguimiento } from '../seguimiento/cliente-seguimiento.js'
import { mostrarPlaneacion } from '../planeacion/interfaz-planeacion.js'
import { mostrarObservaciones } from '../observaciones/interfaz-observaciones.js'
import { listarObservaciones } from '../observaciones/cliente-observaciones.js'
import { mostrarEvaluaciones } from '../evaluaciones/interfaz-evaluaciones.js'
import { mostrarProyecto } from '../proyecto/interfaz-proyecto.js'
import { mostrarCorrespondencia } from '../correspondencia/interfaz-correspondencia.js'
import { abrirReasignacionEstudiante } from '../actores/interfaz-actores.js'
import { cambiarEstadoEstudiante } from '../actores/cliente-actores.js'

const elemento = <T extends Element>(selector: string): T => {
  const encontrado = document.querySelector<T>(selector)
  if (!encontrado) throw new Error(`No existe ${selector}`)
  return encontrado
}
const opcion = (valor: string, texto: string): HTMLOptionElement => {
  const dato = document.createElement('option')
  dato.value = valor
  dato.textContent = texto
  return dato
}
const mensajeError = (error: unknown): string =>
  error instanceof ErrorApi
    ? error.message
    : error instanceof Error
      ? error.message
      : 'No fue posible completar la operación.'

let roles: string[] = []
let expedientes: Expediente[] = []
let identificacionActual: Identificacion | null = null
let departamentos: Ubicacion[] = []
let documentoLegal: DocumentoLegal | null = null
let despuesDeAceptar: (() => void) | null = null
let despuesDeRechazar: (() => void) | null = null
let expedienteActivo: Expediente | null = null
let paginaExpedientes = 1
let totalExpedientes = 0
let limiteExpedientes = 25
let busquedaExpedientes = ''

const alerta = elemento<HTMLElement>('#alerta-expedientes')
const modalLegal = new Modal(elemento('#modal-legal'), { backdrop: 'static', keyboard: false })

function informar(mensaje: string, tipo = 'success'): void {
  alerta.className = 'alert d-none'
  notificar(mensaje, tipo === 'danger' ? 'error' : (tipo as 'success' | 'warning' | 'info'))
}

function textoEnLinea(contenedor: HTMLElement, texto: string): void {
  const partes = texto.split(/(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^\s)]+\))/gu)
  for (const parte of partes) {
    if (!parte) continue
    const enlace = /^\[([^\]]+)\]\(([^\s)]+)\)$/u.exec(parte)
    if (enlace && /^(https?:|mailto:)/u.test(enlace[2]!)) {
      const a = document.createElement('a')
      a.href = enlace[2]!
      a.target = '_blank'
      a.rel = 'noopener noreferrer'
      a.textContent = enlace[1]!
      contenedor.append(a)
    } else if (parte.startsWith('**') && parte.endsWith('**')) {
      const fuerte = document.createElement('strong')
      fuerte.textContent = parte.slice(2, -2)
      contenedor.append(fuerte)
    } else if (parte.startsWith('*') && parte.endsWith('*')) {
      const enfasis = document.createElement('em')
      enfasis.textContent = parte.slice(1, -1)
      contenedor.append(enfasis)
    } else contenedor.append(document.createTextNode(parte))
  }
}

function renderizarDocumentoLegal(contenido: string): void {
  const destino = elemento<HTMLElement>('#contenido-legal')
  destino.replaceChildren()
  const contenidoVisible = contenido
    .replace(
      /,\s*entrenamiento de modelos de inteligencia artificial(?=\s+ni difusión pública)/giu,
      '',
    )
    .replace(/\n\*\*Nombre del titular:[\s\S]*$/u, '')
  const lineas = contenidoVisible.replace(/\r/g, '').split('\n')
  let indice = 0
  while (indice < lineas.length) {
    const linea = lineas[indice]!.trim()
    if (!linea) {
      indice += 1
      continue
    }
    const encabezado = /^(#{1,3})\s+(.+)$/u.exec(linea)
    if (encabezado) {
      const h = document.createElement(encabezado[1]!.length === 1 ? 'h2' : 'h3')
      textoEnLinea(h, encabezado[2]!)
      destino.append(h)
      indice += 1
      continue
    }
    if (/^---+$/u.test(linea)) {
      destino.append(document.createElement('hr'))
      indice += 1
      continue
    }
    const tipoLista = /^(\d+\.)\s+(.+)$/u.test(linea)
      ? 'ol'
      : /^\*\s+(.+)$/u.test(linea)
        ? 'ul'
        : null
    if (tipoLista) {
      const lista = document.createElement(tipoLista)
      while (indice < lineas.length) {
        if (!lineas[indice]!.trim()) {
          indice += 1
          continue
        }
        const elementoLista =
          tipoLista === 'ol'
            ? /^(?:\d+)\.\s+(.+)$/u.exec(lineas[indice]!.trim())
            : /^\*\s+(.+)$/u.exec(lineas[indice]!.trim())
        if (!elementoLista) break
        const li = document.createElement('li')
        textoEnLinea(li, elementoLista[1]!)
        lista.append(li)
        indice += 1
      }
      destino.append(lista)
      continue
    }
    const parrafo: string[] = []
    while (
      indice < lineas.length &&
      lineas[indice]!.trim() &&
      !/^#{1,3}\s|^---+$|^(?:\d+\.|\*)\s+/u.test(lineas[indice]!.trim())
    ) {
      parrafo.push(lineas[indice]!.trim())
      indice += 1
    }
    const p = document.createElement('p')
    textoEnLinea(p, parrafo.join(' '))
    destino.append(p)
  }
}

function llenarUbicaciones(
  selector: string,
  datos: Ubicacion[],
  seleccionado?: string | null,
): void {
  const select = elemento<HTMLSelectElement>(selector)
  select.replaceChildren(opcion('', 'Seleccione…'), ...datos.map((x) => opcion(x.codigo, x.nombre)))
  select.value = seleccionado ?? ''
}

function insigniaEstado(estado: Expediente['estado']): HTMLSpanElement {
  const dato = document.createElement('span')
  dato.className = `badge ${estado === 'ABIERTO' ? 'bg-success' : estado === 'CERRADO' ? 'bg-secondary' : 'bg-warning text-dark'}`
  dato.textContent = estado.charAt(0) + estado.slice(1).toLowerCase()
  return dato
}

function boton(texto: string, clase: string, accion: () => void): HTMLButtonElement {
  const dato = document.createElement('button')
  dato.type = 'button'
  dato.className = `btn btn-sm ${clase} me-1 mb-1`
  dato.textContent = texto
  dato.addEventListener('click', accion)
  return dato
}

function ocultarPanelesExpediente(): void {
  document.querySelectorAll<HTMLElement>('[data-panel-expediente]').forEach((panel) => {
    panel.classList.add('d-none')
  })
}

async function mostrarModuloExpediente(id: string): Promise<void> {
  if (!expedienteActivo) return
  const modulosTitular = new Set(['panel-seguimiento', 'panel-observaciones', 'panel-evaluaciones'])
  if (roles.includes('TITULAR') && !modulosTitular.has(id)) id = 'panel-seguimiento'
  document
    .querySelectorAll<HTMLFormElement>('#vista-modulos-expediente form')
    .forEach((formulario) => {
      formulario.reset()
      formulario.classList.remove('was-validated')
      formulario
        .querySelectorAll('.is-valid,.is-invalid')
        .forEach((campo) => campo.classList.remove('is-valid', 'is-invalid'))
    })
  ocultarPanelesExpediente()
  elemento<HTMLElement>(`#${id}`).classList.remove('d-none')
  document
    .querySelectorAll<HTMLButtonElement>('#nav-modulos-expediente [data-modulo]')
    .forEach((boton) => {
      boton.classList.toggle('active', boton.dataset.modulo === id)
    })
  try {
    if (id === 'panel-seguimiento') await mostrarSeguimiento(expedienteActivo, roles)
    else if (id === 'panel-planeacion') await mostrarPlaneacion(expedienteActivo, roles)
    else if (id === 'panel-observaciones') await mostrarObservaciones(expedienteActivo, roles)
    else if (id === 'panel-evaluaciones') await mostrarEvaluaciones(expedienteActivo, roles)
    else if (id === 'panel-proyecto') await mostrarProyecto(expedienteActivo, roles)
    else if (id === 'panel-correspondencia') await mostrarCorrespondencia(expedienteActivo, roles)
    else if (id === 'panel-identificacion')
      await mostrarIdentificacion(expedienteActivo.estudianteId)
  } catch (error) {
    informar(mensajeError(error), 'danger')
  }
}

function abrirVistaExpediente(expediente: Expediente): void {
  expedienteActivo = expediente
  elemento('#lista-expedientes').classList.add('d-none')
  elemento('#panel-notificaciones').classList.add('d-none')
  elemento('#vista-modulos-expediente').classList.remove('d-none')
  elemento('#estudiante-modulos-expediente').textContent =
    `${expediente.estudianteNombre} · ${expediente.programaNombre} · ${expediente.periodoCodigo}`
  const modulosOcultosTitular = new Set([
    'panel-identificacion',
    'panel-planeacion',
    'panel-proyecto',
    'panel-correspondencia',
  ])
  document
    .querySelectorAll<HTMLButtonElement>('#nav-modulos-expediente [data-modulo]')
    .forEach((boton) => {
      const ocultar =
        roles.includes('TITULAR') && modulosOcultosTitular.has(boton.dataset.modulo ?? '')
      boton.closest('.nav-item')?.classList.toggle('d-none', ocultar)
    })
  const moduloInicial = roles.includes('TITULAR') ? 'panel-seguimiento' : 'panel-identificacion'
  void mostrarModuloExpediente(moduloInicial)
}

function renderizarExpedientes(): void {
  const cuerpo = elemento<HTMLTableSectionElement>('#tabla-expedientes')
  const esAsesor = roles.includes('ASESOR')
  const esCoordinadorAsesores = roles.includes('COORDINADOR_ASESORES')
  cuerpo.replaceChildren(
    ...expedientes.map((expediente) => {
      const fila = document.createElement('tr')
      for (const texto of [
        expediente.estudianteNombre,
        expediente.programaNombre,
        expediente.periodoCodigo,
        expediente.etapa === 'EVALUACION' ? 'Evaluación' : 'Ejecución',
        expediente.asesorNombre,
      ]) {
        const celda = document.createElement('td')
        celda.textContent = texto
        fila.append(celda)
      }
      const estado = document.createElement('td')
      estado.append(insigniaEstado(expediente.estado))
      fila.append(estado)
      const acciones = document.createElement('td')
      acciones.append(boton('Abrir carpeta', 'btn-primary', () => abrirVistaExpediente(expediente)))
      if (esAsesor && expediente.estado === 'PENDIENTE') {
        acciones.append(
          boton('Abrir evaluación', 'btn-success', () => void cambiarEtapa(expediente, 'abrir')),
        )
      }
      if (esAsesor && expediente.estado === 'ABIERTO') {
        acciones.append(
          boton(
            'Cerrar etapa',
            'btn-outline-danger',
            () => void cambiarEtapa(expediente, 'cerrar'),
          ),
        )
      }
      if (esCoordinadorAsesores) {
        acciones.append(
          boton('Asesor', 'btn-outline-primary', () => {
            void abrirReasignacionEstudiante(expediente.estudianteId, 'asesor').catch(
              (error: unknown) => informar(mensajeError(error), 'danger'),
            )
          }),
          boton('Titular', 'btn-outline-primary', () => {
            void abrirReasignacionEstudiante(expediente.estudianteId, 'titular').catch(
              (error: unknown) => informar(mensajeError(error), 'danger'),
            )
          }),
          boton(
            expediente.estudianteUsuarioEstado === 'ACTIVO' ? 'Inactivar' : 'Activar',
            'btn-outline-secondary',
            () => {
              void cambiarEstadoEstudiante(
                expediente.estudianteUsuarioId,
                expediente.estudianteUsuarioVersion,
                expediente.estudianteUsuarioEstado === 'ACTIVO' ? 'INACTIVO' : 'ACTIVO',
              )
                .then(() => cargarExpedientes('Estado del estudiante actualizado.'))
                .catch((error: unknown) => informar(mensajeError(error), 'danger'))
            },
          ),
        )
      }
      if (
        esAsesor &&
        expediente.estado === 'CERRADO' &&
        expediente.etapa === 'EVALUACION' &&
        !expedientes.some(
          (otro) => otro.procesoId === expediente.procesoId && otro.etapa === 'EJECUCION',
        )
      ) {
        acciones.append(
          boton('Abrir ejecución', 'btn-success', () => void cambiarEtapa(expediente, 'abrir')),
        )
      }
      fila.append(acciones)
      return fila
    }),
  )
  elemento('#vacio-expedientes').classList.toggle('d-none', expedientes.length > 0)
  const paginacion = elemento<HTMLElement>('#paginacion-expedientes')
  paginacion.replaceChildren()
  const paginas = Math.max(1, Math.ceil(totalExpedientes / limiteExpedientes))
  for (let pagina = 1; pagina <= paginas; pagina += 1) {
    const enlace = document.createElement('button')
    enlace.type = 'button'
    enlace.className = `btn btn-sm ${pagina === paginaExpedientes ? 'btn-primary' : 'btn-outline-primary'} me-1`
    enlace.textContent = String(pagina)
    enlace.addEventListener('click', () => {
      paginaExpedientes = pagina
      void cargarExpedientes()
    })
    paginacion.append(enlace)
  }
}

async function cambiarEtapa(expediente: Expediente, accion: 'abrir' | 'cerrar'): Promise<void> {
  try {
    if (accion === 'abrir') await abrirExpediente(expediente)
    else await cerrarExpediente(expediente)
    await cargarExpedientes(
      accion === 'abrir' ? 'Etapa abierta correctamente.' : 'Etapa cerrada correctamente.',
    )
  } catch (error) {
    informar(mensajeError(error), 'danger')
  }
}

async function cargarMunicipios(
  departamentoSelector: string,
  municipioSelector: string,
  seleccionado?: string | null,
): Promise<void> {
  const departamento = elemento<HTMLSelectElement>(departamentoSelector).value
  const datos = departamento ? (await listarMunicipios(departamento)).datos : []
  llenarUbicaciones(municipioSelector, datos, seleccionado)
}

function asignar(selector: string, valor: unknown): void {
  elemento<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>(selector).value =
    typeof valor === 'string' ? valor : ''
}

async function mostrarIdentificacion(estudianteId: string): Promise<void> {
  try {
    identificacionActual = await consultarIdentificacion(estudianteId)
    const dato = identificacionActual
    const observador = !roles.includes('ESTUDIANTE')
    // El estado pertenece a la ficha del estudiante, no al rol que la
    // consulta. Se actualiza inmediatamente para que una carga secundaria
    // (por ejemplo, municipios o la foto) no deje visible el estado inicial.
    elemento('#estado-identificacion').textContent = dato.completa
      ? 'Ficha completa'
      : 'Ficha pendiente'
    elemento('#estado-identificacion').className =
      `badge ${dato.completa ? 'bg-success' : 'bg-warning text-dark'}`
    asignar('#nombres-identificacion', `${dato.nombres} ${dato.apellidos}`)
    asignar('#correo-identificacion', dato.correo)
    asignar('#programa-identificacion', dato.programaNombre)
    asignar('#periodo-identificacion', dato.periodoCodigo)
    asignar('#centro-identificacion', `${dato.institucionNombre} — ${dato.sedeNombre}`)
    asignar('#jornada-identificacion', dato.jornadaNombre === 'MANANA' ? 'Mañana' : 'Tarde')
    asignar('#genero-identificacion', dato.genero)
    asignar('#zona-identificacion', dato.zona ?? dato.procedencia)
    asignar('#trayectos-identificacion', dato.trayectosEducativos)
    asignar(
      '#grupo-etnico-identificacion',
      dato.grupoEtnico ?? dato.vulnerabilidadViolenciaMigracion,
    )
    asignar('#celular-identificacion', dato.celular)
    asignar('#arl-identificacion', dato.arl)
    asignar('#direccion-identificacion', dato.direccion)
    llenarUbicaciones(
      '#departamento-nacimiento-identificacion',
      departamentos,
      dato.departamentoNacimientoCodigo ?? dato.departamentoCodigo,
    )
    llenarUbicaciones(
      '#departamento-practica-identificacion',
      departamentos,
      dato.departamentoPracticaCodigo ?? dato.departamentoCodigo,
    )
    if (observador) {
      llenarUbicaciones(
        '#municipio-nacimiento-identificacion',
        dato.municipioNacimientoCodigo
          ? [
              {
                codigo: dato.municipioNacimientoCodigo,
                nombre:
                  dato.municipioNacimientoNombre ??
                  dato.municipioNombre ??
                  dato.municipioNacimientoCodigo,
              },
            ]
          : [],
        dato.municipioNacimientoCodigo,
      )
      llenarUbicaciones(
        '#municipio-practica-identificacion',
        dato.municipioPracticaCodigo
          ? [
              {
                codigo: dato.municipioPracticaCodigo,
                nombre: dato.municipioPracticaNombre ?? dato.municipioPracticaCodigo,
              },
            ]
          : [],
        dato.municipioPracticaCodigo,
      )
    } else {
      await cargarMunicipios(
        '#departamento-nacimiento-identificacion',
        '#municipio-nacimiento-identificacion',
        dato.municipioNacimientoCodigo ?? dato.municipioCodigo,
      )
      await cargarMunicipios(
        '#departamento-practica-identificacion',
        '#municipio-practica-identificacion',
        dato.municipioPracticaCodigo ?? dato.municipioCodigo,
      )
    }
    elemento<HTMLInputElement>('#version-identificacion').value = String(dato.version)
    const foto = elemento<HTMLImageElement>('#foto-identificacion')
    foto.classList.toggle('d-none', !dato.fotoArchivoId)
    elemento<HTMLElement>('#panel-identificacion').classList.toggle(
      'identificacion-observador',
      observador,
    )
    const rutaFoto = dato.fotoArchivoId ? `/api/v1/archivos/${dato.fotoArchivoId}/contenido` : ''
    if (dato.fotoArchivoId) foto.src = rutaFoto
    elemento<HTMLElement>('#tarjeta-perfil-identificacion').classList.toggle('d-none', !observador)
    elemento<HTMLFormElement>('#formulario-identificacion').classList.toggle(
      'identificacion-solo-lectura',
      observador,
    )
    elemento<HTMLElement>('#columna-formulario-identificacion').classList.toggle(
      'col-lg-8',
      observador,
    )
    document
      .querySelector<HTMLElement>('#bloque-carga-foto-identificacion')
      ?.classList.toggle('d-none', observador)
    document
      .querySelector<HTMLElement>('#bloque-vista-foto-identificacion')
      ?.classList.toggle('d-none', observador)
    elemento<HTMLElement>('#nombre-perfil-identificacion').textContent =
      `${dato.nombres} ${dato.apellidos}`
    elemento<HTMLImageElement>('#avatar-identificacion').classList.toggle(
      'd-none',
      !dato.fotoArchivoId,
    )
    elemento<HTMLElement>('#avatar-identificacion-placeholder').classList.toggle(
      'd-none',
      Boolean(dato.fotoArchivoId),
    )
    if (dato.fotoArchivoId) elemento<HTMLImageElement>('#avatar-identificacion').src = rutaFoto
    for (const control of elemento<HTMLFormElement>('#formulario-identificacion').elements) {
      if (
        control instanceof HTMLInputElement ||
        control instanceof HTMLSelectElement ||
        control instanceof HTMLTextAreaElement
      ) {
        const soloLectura = control instanceof HTMLSelectElement ? false : Boolean(control.readOnly)
        if (!soloLectura && control.type !== 'hidden') control.disabled = !dato.puedeEditar
      }
    }
    elemento<HTMLButtonElement>('#guardar-identificacion').classList.toggle(
      'd-none',
      !dato.puedeEditar,
    )
    elemento<HTMLButtonElement>('#cargar-foto-identificacion').classList.toggle(
      'd-none',
      !dato.puedeEditar,
    )
    if (observador) {
      elemento<HTMLFormElement>('#formulario-identificacion')
        .querySelectorAll('input,select,textarea')
        .forEach((control) => {
          const campo = control as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
          const esArchivo = campo instanceof HTMLInputElement && campo.type === 'file'
          if (!campo.value && campo.id !== 'version-identificacion' && !esArchivo) {
            campo.value = 'Diligenciar por el Estudiante'
          }
        })
    }
    elemento('#panel-identificacion').classList.remove('d-none')
    elemento('#panel-identificacion').scrollIntoView({ behavior: 'smooth', block: 'start' })
  } catch (error) {
    informar(mensajeError(error), 'danger')
  }
}

export async function cargarExpedientes(mensaje?: string): Promise<void> {
  try {
    const respuesta = await listarExpedientes({
      pagina: paginaExpedientes,
      limite: limiteExpedientes,
      busqueda: busquedaExpedientes,
    })
    expedientes = respuesta.datos
    totalExpedientes = respuesta.total
    limiteExpedientes = respuesta.limite
    renderizarExpedientes()
    if (roles.includes('ESTUDIANTE') && expedientes[0]) abrirVistaExpediente(expedientes[0])
    if (mensaje) informar(mensaje)
  } catch (error) {
    informar(mensajeError(error), 'danger')
  }
}

export function mostrarListaExpedientes(): void {
  expedienteActivo = null
  paginaExpedientes = 1
  busquedaExpedientes = ''
  elemento<HTMLInputElement>('#filtro-expedientes').value = ''
  ocultarPanelesExpediente()
  elemento('#vista-modulos-expediente').classList.add('d-none')
  elemento('#lista-expedientes').classList.remove('d-none')
}

export async function abrirNotificacionEnExpediente(
  recursoTipo: string,
  recursoId: string,
): Promise<void> {
  let expediente = expedientes
  if (!expediente.length) expediente = (await listarExpedientes()).datos
  let encontrado: Expediente | undefined
  if (recursoTipo === 'OBSERVACION') {
    for (const candidato of expediente) {
      const observaciones = (await listarObservaciones(candidato.id)).datos
      if (observaciones.some((observacion) => observacion.id === recursoId)) {
        encontrado = candidato
        break
      }
    }
  } else if (['ASESORIA', 'APOYO', 'DIARIO'].includes(recursoTipo)) {
    const modulo =
      recursoTipo === 'ASESORIA' ? 'asesorias' : recursoTipo === 'APOYO' ? 'apoyos' : 'diarios'
    for (const candidato of expediente) {
      const registros = (await listarSeguimiento(candidato.id, modulo)).datos
      if (registros.some((registro) => registro.id === recursoId)) {
        encontrado = candidato
        break
      }
    }
  } else {
    encontrado = expediente.find((dato) => dato.id === recursoId)
  }
  if (!encontrado) return
  abrirVistaExpediente(encontrado)
  const modulo =
    recursoTipo === 'OBSERVACION'
      ? 'panel-observaciones'
      : ['ASESORIA', 'APOYO', 'DIARIO'].includes(recursoTipo)
        ? 'panel-seguimiento'
        : recursoTipo === 'CORRESPONDENCIA'
          ? 'panel-correspondencia'
          : recursoTipo === 'PROYECTO'
            ? 'panel-proyecto'
            : 'panel-evaluaciones'
  await mostrarModuloExpediente(modulo)
}

export function configurarInterfazExpedientes(nuevosRoles: string[]): void {
  roles = nuevosRoles
  elemento<HTMLInputElement>('#filtro-expedientes').placeholder = nuevosRoles.includes(
    'COORDINADOR_ASESORES',
  )
    ? 'Buscar por nombre, apellido o asesor'
    : 'Buscar por nombre, apellido o institución'
  if (!departamentos.length) {
    void listarDepartamentos()
      .then((respuesta) => {
        departamentos = respuesta.datos
        llenarUbicaciones('#departamento-nacimiento-identificacion', departamentos)
        llenarUbicaciones('#departamento-practica-identificacion', departamentos)
      })
      .catch(() => undefined)
  }
}

export async function solicitarDecisionLegal(
  alAceptar: () => void,
  alRechazar: () => void,
): Promise<void> {
  despuesDeAceptar = alAceptar
  despuesDeRechazar = alRechazar
  documentoLegal = await consultarDocumentoLegal()
  renderizarDocumentoLegal(documentoLegal.contenido)
  elemento<HTMLInputElement>('#confirmacion-legal').checked = false
  elemento<HTMLButtonElement>('#aceptar-legal').disabled = true
  elemento('#alerta-legal').className = 'alert d-none'
  modalLegal.show()
}

export function prepararInterfazExpedientes(): void {
  llenarUbicaciones('#departamento-nacimiento-identificacion', [])
  llenarUbicaciones('#municipio-nacimiento-identificacion', [])
  llenarUbicaciones('#departamento-practica-identificacion', [])
  llenarUbicaciones('#municipio-practica-identificacion', [])
}

elemento<HTMLFormElement>('#formulario-filtro-expedientes').addEventListener('submit', (evento) => {
  evento.preventDefault()
  paginaExpedientes = 1
  busquedaExpedientes = elemento<HTMLInputElement>('#filtro-expedientes').value.trim()
  void cargarExpedientes()
})

document
  .querySelectorAll<HTMLButtonElement>('#nav-modulos-expediente [data-modulo]')
  .forEach((boton) => {
    boton.addEventListener('click', () => {
      void mostrarModuloExpediente(boton.dataset.modulo ?? '')
    })
  })

elemento<HTMLButtonElement>('#volver-lista-expedientes').addEventListener('click', () => {
  expedienteActivo = null
  ocultarPanelesExpediente()
  elemento('#vista-modulos-expediente').classList.add('d-none')
  elemento('#lista-expedientes').classList.remove('d-none')
})

for (const [departamento, municipio] of [
  ['#departamento-nacimiento-identificacion', '#municipio-nacimiento-identificacion'],
  ['#departamento-practica-identificacion', '#municipio-practica-identificacion'],
] as const) {
  elemento<HTMLSelectElement>(departamento).addEventListener('change', () => {
    void cargarMunicipios(departamento, municipio).catch((error: unknown) =>
      informar(mensajeError(error), 'danger'),
    )
  })
}

elemento<HTMLFormElement>('#formulario-identificacion').addEventListener('submit', (evento) => {
  evento.preventDefault()
  const formulario = evento.currentTarget as HTMLFormElement
  formulario.classList.add('was-validated')
  if (!formulario.checkValidity() || !identificacionActual) return
  const dato = identificacionActual
  void actualizarIdentificacion(dato.estudianteId, {
    genero: elemento<HTMLSelectElement>('#genero-identificacion').value,
    zona: elemento<HTMLSelectElement>('#zona-identificacion').value,
    grupoEtnico: elemento<HTMLSelectElement>('#grupo-etnico-identificacion').value,
    trayectosEducativos: elemento<HTMLSelectElement>('#trayectos-identificacion').value,
    celular: elemento<HTMLInputElement>('#celular-identificacion').value,
    arl: elemento<HTMLSelectElement>('#arl-identificacion').value,
    direccion: elemento<HTMLInputElement>('#direccion-identificacion').value,
    departamentoNacimientoCodigo: elemento<HTMLSelectElement>(
      '#departamento-nacimiento-identificacion',
    ).value,
    municipioNacimientoCodigo: elemento<HTMLSelectElement>('#municipio-nacimiento-identificacion')
      .value,
    departamentoPracticaCodigo: elemento<HTMLSelectElement>('#departamento-practica-identificacion')
      .value,
    municipioPracticaCodigo: elemento<HTMLSelectElement>('#municipio-practica-identificacion')
      .value,
    version: Number(elemento<HTMLInputElement>('#version-identificacion').value),
  })
    .then((actualizada) => mostrarIdentificacion(actualizada.estudianteId))
    .then(() => informar('Ficha actualizada correctamente.'))
    .catch((error: unknown) => informar(mensajeError(error), 'danger'))
})

elemento<HTMLButtonElement>('#cargar-foto-identificacion').addEventListener('click', () => {
  const archivo = elemento<HTMLInputElement>('#archivo-foto-identificacion').files?.[0]
  if (!archivo || !identificacionActual) {
    informar('Seleccione una foto PNG o JPEG.', 'danger')
    return
  }
  if (archivo.size > 10 * 1024 * 1024) {
    informar('La foto supera el límite permitido de 10 MB.', 'danger')
    return
  }
  mostrarCarga('Verificando y subiendo la fotografía…')
  void cargarFotoIdentificacion(
    identificacionActual.estudianteId,
    archivo,
    Number(elemento<HTMLInputElement>('#version-identificacion').value),
  )
    .then((actualizada) => mostrarIdentificacion(actualizada.estudianteId))
    .then(() => informar('Foto verificada y registrada.'))
    .catch((error: unknown) => informar(mensajeError(error), 'danger'))
    .finally(cerrarCarga)
})

elemento<HTMLInputElement>('#confirmacion-legal').addEventListener('change', (evento) => {
  elemento<HTMLButtonElement>('#aceptar-legal').disabled = !(
    evento.currentTarget as HTMLInputElement
  ).checked
})

async function decidirLegal(resultado: 'ACEPTADO' | 'RECHAZADO'): Promise<void> {
  if (!documentoLegal) return
  const alertaLegal = elemento('#alerta-legal')
  try {
    await decidirDocumentoLegal(documentoLegal, resultado)
    modalLegal.hide()
    if (resultado === 'ACEPTADO') despuesDeAceptar?.()
    else despuesDeRechazar?.()
  } catch (error) {
    alertaLegal.className = 'alert d-none'
    notificar(mensajeError(error), 'error')
  }
}

elemento<HTMLButtonElement>('#aceptar-legal').addEventListener('click', () => {
  void decidirLegal('ACEPTADO')
})
elemento<HTMLButtonElement>('#rechazar-legal').addEventListener('click', () => {
  void decidirLegal('RECHAZADO')
})
